import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL

console.log("API_BASE_URL", API_BASE_URL);


const axiosInstance = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

export const doGet = async (url, params = {}) => {
    const response = await axiosInstance.get(url, { params });
    return response.data;
};

export const doPost = async (url, data = {}, config = {}) => {
    const response = await axiosInstance.post(url, data, config);
    return response.data;
};

export const doPut = async (url, data = {}) => {
    const response = await axiosInstance.put(url, data);
    return response.data;
};

export const doDelete = async (url) => {
    const response = await axiosInstance.delete(url);
    return response.data;
};

export default axiosInstance;